/* Aurora 2027 en Shopify — aplica los precios en vivo (window.AU_PRECIOS) sobre los datos del sitio, antes de pintar nada. */
(function(){
"use strict";
const P = window.AU_PRECIOS, A = window.AURORA;
if (!P || !A) return;
const nSes = v => +(((v.o.sesiones || v.o.pack || "") + "").match(/\d+/) || [0])[0];
A.productos.forEach(p => {
  p.vars.forEach(v => { const x = P[v.id]; if (!x) { v.ok = false; return; } v.p = x[0]; v.a = x[1] > x[0] ? x[1] : null; v.ok = !!x[2]; });
  const vs = p.vars.filter(v => v.ok); if (!vs.length) return;
  const min = vs.reduce((m, v) => v.p < m.p ? v : m); p.p = min.p; p.a = min.a;
  (p.ses || []).forEach(s => { const c = vs.filter(v => nSes(v) === s.n); if (c.length) { const m = c.reduce((a, b) => b.p < a.p ? b : a); s.precio = m.p; s.antes = m.a; } });
});
if (A.giftcard && A.giftcard.vars) Object.entries(A.giftcard.vars).forEach(([monto, id]) => { if (!P[id]) delete A.giftcard.vars[monto]; });
})();
